import React, { useState, useEffect, createRef } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import { selectUsers } from "../state/reducers/userSlice";
import { Multiselect } from "multiselect-react-dropdown";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import facilityService from "../services/facility-service";
import patientService from "../services/patient-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { updatePatId } from "../state/reducers/patientSlice";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

const CreatePatient = ({ history }) => {
  const [facilityList, setFacilitiesList] = useState();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  let { user } = useSelector(selectUsers);
  const [access, setAccess] = useState({});
  const [fileContent, setFileContent] = useState({});

  const { register, handleSubmit, errors } = useForm({});
  const [patientdetails, setPatientDetails] = useState();
  const [dob, setDate] = useState();
  const [gender, setGender] = useState();
  const [facility, setFacility] = useState("");
  const [status, setStatus] = useState("");
  const [account, setAccount] = useState();
  const [accountsList, setAccountsList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState();
  const [mname, setMname] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [is_kop, setIsKop] = useState(true);
  const dispatch1 = useDispatch();
  useEffect(() => {
    getFacilities();
    getStatus();
  }, []);
  useEffect(() => {
    if (id) getPatientDetails(id);
  }, [id]);
  useEffect(() => {
    if (facility) getAccounts(facility);
  }, [facility]);
  const getAccessForFacility = async (id) => {
    try {
      let resp = await facilityService.getAccessForFacilities(id);
      setAccess(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };


  const getPatientDetails = async (id) => {
    try {
      setLoading(true);
      const resp = await patientService.getPatientsByID(id);
      getAccessForFacility(resp?.fac_id || user?.facility);

      setPatientDetails(resp);
      // no allergies dont set
      if(resp?.allergies.length > 0){
        setAllergy(resp?.allergies);
      }
      setGender(resp?.gender);
      setStatus(resp?.status);
      setFacility(resp?.fac_id || user?.facility);
      setAccount(resp?.chg_id);
      setLoading(false);
      setDate(new Date(resp.dob));
      setMname(resp?.mname || "");
      setIdNumber(resp?.id_number);
      setAccountNumber(resp?.acct_number);
      setIsKop(resp?.slf_cry_flag === "F" ? false : true);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting patient details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  async function getFacilities() {
    try {
      setLoading(true);
      let totalFacList = await facilityService.getFacilities();
      totalFacList.sort((a, b) => a.name.localeCompare(b.name));
      setFacilitiesList(totalFacList);
      setLoading(false);
      if (!id) setFacility(user?.facility);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  async function getAccounts() {
    try {
      setLoading(true);
      let resp = await patientService.getChargeAccounts(facility);
      setAccountsList(resp);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting accounts. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  async function getStatus() {
    try {
      setLoading(true);
      let resp = await patientService.getStatus();
      setStatusList(resp);
      setLoading(false);
      setStatus(patientService?.status);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting status. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const [cusError, setCusError] = useState(false);
  const onSubmit = async (data) => {
    try {
      if (allergy.length === 0 || !dob) {
        setCusError(true);
        return;
      }
      setLoading(false);
      data["dob"] = dob;
      data["chg_id"] = account;
      data["mname"] = mname;
      data["acct_number"] = accountNumber;
      data["id_number"] = idNumber;
      data["allergies"] = allergy;
      data["slf_cry_flag"] = is_kop ? "T" : "F";
      if (patientdetails?.id) {
        data["id"] = patientdetails.id;
      }
      delete data.account;
      if (fileContent?.name) {
        let formDataUrl = new FormData();
        formDataUrl.append("formFile", fileContent);
        formDataUrl.append("enctype", "multipart/form-data");
        const resp = await patientService.uploadProfile(formDataUrl);
        data["profile_pic"] = resp;
      } else {
        data["profile_pic"] = patientdetails?.profile_pic || "";
      }
      const response = await patientService.createPatient(data);
      setLoading(false);
      if (patientdetails?.id) {
        await history.push("/patients");
      } else {
        dispatch1(updatePatId([response]));
        await history.push("/patientDetails");
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while submitting patient details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const multiselectRefAllergy = createRef();
  const [allergy, setAllergy] = useState([]);
  const [allergyList, setAllergyList] = useState([]);
  const getAllergies = async (search) => {
    if (search.trim().length >= 2) {
      setAllergyList([]);
      try {
        let response = await patientService.getAllergies(search);
        setAllergyList([...response]);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving allergies. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
  const [image, setImage] = useState(null);
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
    }
   }


  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">
              {id ? "EDIT PATIENT" : "CREATE PATIENT"}
            </span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-left">
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <div className="flex">
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr w-full font-semibold text-sm tracking-wider">
                        First Name
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1">
                        *
                      </span>
                    </div>
                    <input
                      id="fname"
                      name="fname"
                      type="text"
                      placeholder="First Name"
                      ref={register({
                        required: "You must specify first name",
                      })}
                      defaultValue={patientdetails?.fname || ""}
                      className={` ${
                        errors.first_name ? "border-red-400" : ""
                      } border focus:outline-none h-11 rounded-md pl-2  font-normal w-5/6 text-fogotpwsd_login text-sm`}
                    />

                    {errors.fname && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        {errors.fname?.message}
                      </p>
                    )}
                  </span>
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Last Name
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1">
                        *
                      </span>
                    </div>
                    <input
                      id="lname"
                      name="lname"
                      type="text"
                      placeholder="Last Name"
                      autoComplete="lastname"
                      defaultValue={patientdetails?.lname || ""}
                      ref={register({
                        required: "You must specify last name",
                      })}
                      className={` ${
                        errors.lname ? "border-red-400" : ""
                      } border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                    />

                    {errors.lname && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        {errors.lname?.message}
                      </p>
                    )}
                  </span>
                </div>
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <div className="flex">
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Middle Name
                      </label>
                    </div>
                    <input
                      id="mname"
                      name="mname"
                      type="text"
                      placeholder="Middle Name"
                      value={mname}
                      onChange={(e) => setMname(e.target.value)}
                      className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                    />
                  </span>
                  <span className="w-1/2">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Date of Birth (MM/DD/YYYY)
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <DatePicker
                      placeholderText="MM/DD/YYYY"
                      customInput={
                        <MaskedInput
                          pipe={autoCorrectedDatePipe}
                          mask={[
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          keepCharPositions={true}
                          guide={true}
                        />
                      }
                      selected={dob}
                      onChange={(dob) => {
                        setDate(dob);
                      }}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12  text-fogotpwsd_login text-sm"
                    />
                    {cusError && !dob && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify date of birth
                      </p>
                    )}
                  </span>
                </div>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <div className="flex">
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Account Number
                      </label>
                    </div>
                    <input
                      id="acct_number"
                      name="acct_number"
                      type="text"
                      placeholder="Account Number"
                      onChange={(e) => setAccountNumber(e.target.value)}
                      value={accountNumber}
                      className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm`}
                    />
                  </span>
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Status
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                        *
                      </span>
                    </div>
                    <select
                      name="status"
                      aria-label="Select Status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      ref={register({
                        required: "You must select status",
                      })}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm"
                    >
                      <option value="">Select Status</option>
                      {statusList
                        ? statusList.map((status, i) => {
                            return (
                              <option key={status?.key} value={status?.key}>
                                {status?.value}
                              </option>
                            );
                          })
                        : null}
                    </select>
                    {errors.status && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify status
                      </p>
                    )}
                  </span>
                </div>
              </li>

              <li className="inline-block text-xs leading-6 w-full mb-4">
                <div className="flex">
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Gender
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                        *
                      </span>
                    </div>
                    <select
                      name="gender"
                      aria-label="Select Gender"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      ref={register({
                        required: "You must select gender",
                      })}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm"
                    >
                      <option value="">Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="U">Others</option>
                    </select>
                    {errors.gender && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify gender
                      </p>
                    )}
                  </span>
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Patient Facility
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1">
                        *
                      </span>
                    </div>
                    {facilityList ? (
                      <select
                        name="fac_id"
                        aria-label="Select Facility"
                        onChange={(e) => {
                          setFacility(e.target.value);
                          getAccessForFacility(e.target.value);
                        }}
                        value={facility}
                        ref={register({
                          required: "You must select facility",
                        })}
                        className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm"
                      >
                        <option value="">Select Facility</option>
                        {facilityList
                          ? facilityList.map((facility, i) => {
                              return (
                                <option key={facility.id} value={facility.id}>
                                  {facility.name}
                                </option>
                              );
                            })
                          : null}
                      </select>
                    ) : (
                      ""
                    )}

                    {errors.fac_id && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify facility
                      </p>
                    )}
                  </span>
                </div>
              </li>

              <li className="inline-block text-xs leading-6 w-full mb-4">
                <div className="flex">
                  <span className="w-1/2">
                    <div>
                      <label className="text-labelclr font-semibold text-sm tracking-wider">
                        Charge Code
                      </label>
                      <span className="text-xs md:text-sm text-hlred ml-1">
                        *
                      </span>
                    </div>
                    {accountsList ? (
                      <select
                        name="account"
                        aria-label="Select Account"
                        onChange={(e) => {
                          var selectedItem = accountsList.find(
                            (item) =>
                              item?.chg_id?.toString() === e.target.value
                          );
                          setSelectedAccount(selectedItem);
                          setAccount(e.target.value);
                        }}
                        value={account}
                        ref={register({
                          required: "You must select charge account",
                        })}
                        className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-5/6 text-fogotpwsd_login text-sm"
                      >
                        <option value="">Select Account</option>
                        {accountsList.map((account, i) => {
                          return (
                            <option key={account.chg_id} value={account.chg_id}>
                              {account.chg_acct}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      ""
                    )}
                    {errors.account && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify charge account
                      </p>
                    )}
                  </span>
                  <span className="w-1/2">
                    {(selectedAccount?.thp_id?.length > 0 ||
                      patientdetails?.id_number?.length > 0) && (
                      <span>
                        <label className="text-labelclr font-semibold text-sm tracking-wider">
                          Third party ID
                        </label>
                        <input
                          id="id_number"
                          name="id_number"
                          placeholder="Enter Third party ID"
                          type="text"
                          value={idNumber}
                          onChange={(e) => setIdNumber(e.target.value)}
                          className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-5/6"
                        />
                      </span>
                    )}
                  </span>
                </div>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <div className="flex">
                  <span className="w-10/12 mr-4">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Allergies
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    {allergyList ? (
                      <Multiselect
                        name="allergyList"
                        displayValue="text"
                        selectedValues={allergy}
                        options={allergyList}
                        ref={multiselectRefAllergy}
                        avoidHighlightFirstOption={true}
                        hidePlaceholder={true}
                        onSelect={(selectedList, selectedItem) => {
                          setAllergy(selectedList);
                        }}
                        onSearch={(value) => {
                          getAllergies(value);
                        }}
                        onRemove={(selectedList, removedItem) => {
                          setAllergy(selectedList);
                        }}
                      />
                    ) : (
                      ""
                    )}
                    {cusError && allergy.length === 0 && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify allergies
                      </p>
                    )}
                  </span>
                  <span className="w-2/12">
                    <button
                      type="button"
                      className="text-white w-full h-12  py-2 mt-6 bg-header_bg rounded text-xs font-semibold capitalize"
                      onClick={() => {
                        setAllergy([
                          {
                            allergy_id: "276574",
                            text: "No Known Allergies",
                            type: "NULL",
                          },
                        ]);
                      }}
                    >
                      No Known Allergies
                    </button>
                  </span>
                </div>
              </li>
              {access?.is_kop === "T" && (    <li className="mb-4">
                <span className="mb-4">
                  <input
                    type="checkbox"
                    id="is_kop"
                    name="is_kop"
                    checked={is_kop}
                    value={is_kop}
                    onChange={(e) => setIsKop(e.target.checked)}
                  />
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    {" "}
                    KOP Privileges
                  </label>
                </span>
              </li>)}
              <li className="inline-block text-xs leading-8 w-full">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Upload Profile Picture
                </label>
                <input
                  id="upload"
                  name="upload"
                  type="file"
                  onChange={(e) => {
                    setFileContent(e.target.files[0]);
                    onImageChange(e);
                  }}
                  className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2"
                />
               {image && <img alt="" src={image}/>}
              </li>

              <li>
                <button
                  type="submit"
                  className="text-white w-full h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-semibold capitalize"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreatePatient)
);
